<template>
  <div class="md-layout-item md-small-size-100 md-size-50 mb-4">
    <h4>{{ label }}</h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: "CardGroup",
  props: {
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
h4 {
  font-size: 1.1em;
  margin-bottom: 5px;
}
</style>
